import React from 'react';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import classNames from 'classnames';

import ManualScriptingCard from './ManualScriptingCard';

const baseString = 'vra-fertility-script-options';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-script-type-options': true
});
const FertilityScriptOptions = ({
  canCreateManualScript,
  isApplication,
  onClickManualScriptTrigger
}) => (
  <section className={classString}>
    <ManualScriptingCard
      canCreateManualScript={canCreateManualScript}
      cardText={isApplication ? getMessage('text__create-manual-application-script')
        : getMessage('text__create-manual-fertility-script')}
      cardTitle={isApplication ? getMessage('title-text__manual-application-script') 
        : getMessage('title-text__manual-fertility-script')}
      onClickManualScriptTrigger={onClickManualScriptTrigger}
    />
  </section>
);
FertilityScriptOptions.propTypes = {
  canCreateManualScript: propTypes.bool.isRequired,
  isApplication: propTypes.bool.isRequired,
  onClickManualScriptTrigger: propTypes.func,
};
export default FertilityScriptOptions;
